import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};

const PencilIcon = ({ color = '#0d84fe', size = '12px', ...props }) => (
  <svg width={size} height={size} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M1.317.16.16 1.317a.545.545 0 0 0 0 .771l1.427 1.427 1.928-1.928L2.088.16a.545.545 0 0 0-.771 0Zm2.97 2.198L2.357 4.286 10.072 12H12v-1.928L4.286 2.358Z"
      fill={color}
      fillRule="evenodd"
    />
  </svg>
);

PencilIcon.propTypes = propTypes;

export default PencilIcon;
